

const quantityDiscounts = JSON.parse(document.getElementById('quantity-discounts').textContent)
let hasScrolledToAddOns = false;

!customElements.get('hoculus-quantity-discounts-variant-list') && customElements.define('hoculus-quantity-discounts-variant-list', class extends HTMLElement {
    constructor() {
        super();

        this.variantId = this.dataset.variantId;

        this.form = document.querySelector('.product__info-container product-form form');

        this.idInput = this.form.querySelector('input[name="id"]');
        this.qtyInput = this.form.querySelector('input[name="quantity"]');

        this.idInput?.remove();
        this.qtyInput?.remove();

        this.addEventListener('change', ({ target: { value: variantId } }) => this.onVariantChange(variantId));


        // Override XHR
        this.overrideXHR(); // Needed to make [Zipify OCU](https://apps.shopify.com/zipify-oneclickupsell) app work
    }

    overrideXHR() {
        const XHR = XMLHttpRequest;
        const send = XHR.prototype.send;

        const variantId = parseInt(this.variantId);
        
        XHR.prototype.send = function(data) {
            let json;

            try {
                json = JSON.parse(data);
            } catch (error) {
                // Not a valid JSON
            }

            // Line item with no variant_id set
            const lineItem = json?.line_items?.find(item => item.variant_id == null);

            if (lineItem) {
                lineItem.variant_id = variantId;
            }

            send.call(this, json ? JSON.stringify(json) : data);
        }
    }

    onVariantChange(variantId) {
        document.dispatchEvent(new CustomEvent(window.hoculus.CUSTOM_EVENTS.VARIANT_CHANGED, { detail: { variantId }}));
    }
});

!customElements.get('hoculus-quantity-discount') && customElements.define('hoculus-quantity-discount', class extends HTMLElement {
    constructor() {
        super();

        this.priceEl = this.querySelector('[data-price]');
        this.subtitleEl = this.querySelector('.quantity-discount__info .metafield-rich_text_field p');

        this.radioInput = this.querySelector('input[type="radio"]');

        this.atcForm = document.querySelector('.product__info-container product-form form');

        this.qtyDiscountsError = document.querySelector('[data-quantity-discounts] .product__quantity-discounts--error');

        this.addOnsBlock = document.querySelector('hoculus-add-ons');

        document.addEventListener(window.hoculus.CUSTOM_EVENTS.VARIANT_CHANGED, () => {
            if (this.interval) {
                clearInterval(this.interval);
            }
            
            // Waiting for the radio input checked attribute to be set
            this.interval = setTimeout(() => {
                this.onVariantChange();
            }, 500);
        });

        this.addEventListener('change', this.onVariantChange.bind(this));
        this.onVariantChange();
    }

    onVariantChange() {
        const checkedVariants = Array.from(this.querySelectorAll(`.quantity-discount__body input[type="radio"]:checked`)).map(input => input.value);

        const foundCombination = quantityDiscounts.find(({ quantity }) => quantity === checkedVariants.length);      

        const combination = this.findCombination(foundCombination.discountCombinations, this.findActiveVariantsCount(checkedVariants));

        if (!combination) {
            return;
        }

        this.updatePrice(combination);
        this.updateSubtitle(combination);

        const isOpen = this.radioInput.checked;

        if (isOpen) {
            this.appendInputsToForm(combination);

            this.qtyDiscountsError.classList.add('hidden');

            
            if (!hasScrolledToAddOns) {
                this.addOnsBlock.classList.remove('hidden');
                this.addOnsBlock.classList.add('qty_selected');

                this.scrollIntoView({ behavior: "smooth" });
                hasScrolledToAddOns = true;
            }

            // Applying discount code as soon as combination is found
            if (combination.discountCode) this.applyDiscountCode(combination.discountCode);
        }
    }

    findCombination(combinations, activeVariantsCount) {
        for (const combination of combinations) {

            let found = 0;

            for (const key in activeVariantsCount) {

                for (const item of combination.items) {
                    const itemFound = item.quantity === activeVariantsCount[key] && key == item.variant;
                    
                    if (!itemFound) {
                        continue;
                    }

                    found++;
                }

            }

            if (found > 0) return combination;
        }
    }

    findActiveVariantsCount(variants) {
        return variants.reduce((acc, variant) => {
            acc[variant] = acc[variant] ? acc[variant] + 1 : 1
            return acc;
        }, {});
    }

    updatePrice(combination) {
        const totalPrice = this.getCombinationPrice(combination) / 100;
        const discountPrice = totalPrice - combination.discount;

        const fullPrice = (totalPrice === discountPrice && combination.items.length === 1) ? combination.items[0].variantCompareAtPrice : totalPrice * 100

        this.priceEl.innerHTML = `
            ${window.Shopify.formatMoney(discountPrice * 100)}
            ${fullPrice > 0 ? `
                <br />
                <span class="full-price">${window.Shopify.formatMoney(fullPrice)}</span>
            ` : ''}
        `;
    }

    getCombinationPrice(combination) {
        return combination.items.reduce((acc, item) => acc + (item.variantPrice * item.quantity), 0);
    }

    updateSubtitle(combination) {
        if (!this.originalSubtitle) this.originalSubtitle = this.subtitleEl.innerHTML;

        const lastChecked = Array.from(this.querySelectorAll(`.quantity-discount__body input[type="radio"]:checked`)).at(-1);
        const lastCheckedVariantId = lastChecked.value;

        const lastCheckedVariant = combination.items.find(item => item.variant === parseInt(lastCheckedVariantId));

        const discount = lastCheckedVariant.variantPrice - (combination.discount * 100);

        this.subtitleEl.innerHTML = this.originalSubtitle.replace('[]', window.Shopify.formatMoney(discount, `${window.Shopify.money_format[0]}{{amount_no_decimals}}`));
    }

    appendInputsToForm(combination) {
        const inputsHTML = combination.items.reduce((html, item, i) => {
            const index = 50 + i;

            return html +`
                <input type="hidden" name="items[${index}][id]" value="${item.variant}">
                <input type="hidden" name="items[${index}][quantity]" value="${item.quantity}">
                ${item.variantIsAvailable === false ? (
                 `<input type="hidden" name="items[${index}][properties][${item.variantPreOrderProperty.key}]" value="${item.variantPreOrderProperty.value}">
                  <input type="hidden" name="items[${index}][properties][_hoculus-pre-order]" value="true" />
                 `
                ) : ''}
            `;
        }, '');

        this.atcForm.querySelector('.hoculus-inputs-wrapper')?.remove();

        this.atcForm.insertAdjacentHTML('beforeend', `
            <span class="hoculus-inputs-wrapper">${inputsHTML}</span>    
        `);
    }

    async applyDiscountCode(code) {
        try {
            const formData = new FormData();
            formData.append('discount', code);

            const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                body: formData
            });

            if (!response.ok) throw new Error(`Failed to apply discount code: ${code}`);
        } catch (err) {
            console.log('Discount application error:\n', err.message);
        }
    }
});

!customElements.get('hoculus-quantity-discount-row') && customElements.define('hoculus-quantity-discount-row', class extends HTMLElement {
    constructor() {
        super();

        this.imageEl = this.querySelector('[data-variant-image]');
        this.titleEl = this.querySelector('[data-variant-title]')

        document.addEventListener(window.hoculus.CUSTOM_EVENTS.VARIANT_CHANGED, ({ detail: { variantId }}) => this.onVariantChange(variantId));
        this.addEventListener('change', this.onInnerVariantChange.bind(this));
    }

    onVariantChange(variantId) {
        const input = this.querySelector(`input[type="radio"][value="${variantId}"]`);
        
        if (input) {
            input.checked = true;

            this.updateImageSrc(input.nextElementSibling.querySelector('img').src);
            this.updateVariantTitle(input.dataset.variantTitle);
        }
    }

    onInnerVariantChange({ target }) {
        this.updateImageSrc(target.nextElementSibling.querySelector('img').src);
        this.updateVariantTitle(target.dataset.variantTitle);
    }

    updateImageSrc(src) {
        this.imageEl.src = src;
        this.imageEl.removeAttribute('srcset');
    }
    
    updateVariantTitle(title) {
        this.titleEl.textContent = title;
    }
});